module.exports = __webpack_public_path__ + "img/jfmx1.368c9d4e.png";